import { useQuery } from 'react-query'
import { QUERY_KEYS } from 'src/constants'

import { userService } from 'src/services/user.service'

export const useCreate2faTotpUrl = () => {
  return useQuery([QUERY_KEYS.TOTP_URI], () => userService.create2FATotpUrl(), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  })
}
